import React from "react";
import NavigationComponent from "../calendar/components/NavigationComponent";
import { AthleteLinks } from "../../../parts/athlete-links";
import { AthleteSelect } from "../../../parts/inputs/athlete-select-new";
import getAvatarUrl from "../../../utils/get-avatar-url";

export const ReportsMenu = ({ locals }) => {
  const { query, pathname, athlete } = locals;

  return (
    <>
      <div className="athlete-section-header only-show-mobile">
        <AthleteLinks
          athlete={athlete}
          pathName={pathname}
          classNames={"only-show-mobile"}
        />
        <div className="athlete-select dropdown-athlete">
          <div
            className="avatar"
            style={{
              backgroundImage: `url(${getAvatarUrl(locals.athlete)})`,
            }}
          />
          <AthleteSelect locals={locals} />
        </div>
      </div>
      <NavigationComponent
        query={query}
        text="Reports Menu"
        pathName={pathname}
        classNames="only-show-mobile"
      />
    </>
  );
};
